import Request from 'superagent';
import Promise from 'babel-runtime/core-js/promise';
import _map from '../../node_modules/lodash/map';
import { sessionEndedRedirect } from 'utilities/userDeactivation';

/**
 * @method 200 success( $message, $data = [] )
 * @method 400 badRequest( $message )
 * @method 401 unauthorized( $message )
 * @method 403 not implemented
 * @method 404 notFound( $message )
 * @method 422 failedValidation( $message )
 * @method 500 error( $message )
**/

let ajax = function ajax( method = 'GET', url='/', data={}, handleProgress = ()=>{} )
{
	return new Promise( (resolve, reject) => {
		let request = Request( method, url )

		request.set('Accept', 'application/json');

		if( method === 'GET' )
		{
			request.query( data )
		}

		if( method === 'POST' || method === 'PUT' )
		{
			//for a file upload we need to handle
			//attaching the data a little bit different
			if( typeof data.file !== 'undefined' )
			{
				//since we have a file attach the progress event
				request.on('progress', event => {
					handleProgress( event, data.file )
				})

				//loop over data object, attach data and the file object
				_map(data, ( value, key ) => {

					//if we have a File object attach it
					if( key == 'file' )
					{
						request.attach(data.file.name, data.file)
						return
					}

					//all other data attach as fields
					request.field(key, value)
				})
				// request.attach(data.file.name, data.file)
			}
			else
			{
				request.send( data )
			}
		}

		request.end( ( err, res ) => {

			//a deactivated user or a timed-out login ends the session: reload onto the login form with the reason
			const sessionEndedUrl = sessionEndedRedirect(res.status, res.body)
			if( sessionEndedUrl )
			{
				window.location.assign(sessionEndedUrl);
			}

			//every status resolves, never rejects: the login form reads the 401/403 bodies
			resolve({
				statusCode: res.status,
				body:       res.body
			})
		})
	})
}

export default {
	get: function( url, data = {}, passThroughData )
	{
		return ajax( 'GET', url, data, passThroughData );
	},

	post: function( url, data, passThroughData )
	{
		return ajax( 'POST', url, data, passThroughData );
	},

	put: function (url, data, passThroughData)
	{
		return ajax('PUT', url, data, passThroughData);
	},

	delete: function (url, data = {}, passThroughData) {
		return ajax('DELETE', url, data, passThroughData);
	}
}
